
export default {
    props: {
        jam: Object
    }
}
